/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type OAuthConnectionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OAuthConnectionsQuery = { __typename: 'Query', oauthConnections?: { __typename: 'OAuthConnectionTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'OAuthConnectionTypeEdge', node?: { __typename: 'OAuthConnectionType', id: string, connectionType?: Types.OAuthIntegrationTypeEnum | null, expiresAt: string, isActive: boolean } | null } | null> } | null };

export type CreateMicrosoftOAuthUrlMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateMicrosoftOAuthUrlMutation = { __typename: 'Mutation', createMicrosoftOauthUrl?: { __typename: 'CreateMicrosoftOAuthUrlMutation', oauthUrl?: { __typename: 'MicrosoftOAuthUrlType', url: string, state: string } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type CompleteMicrosoftOAuthMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type CompleteMicrosoftOAuthMutation = { __typename: 'Mutation', completeMicrosoftOauth?: { __typename: 'CompleteMicrosoftOAuthMutation', connection?: { __typename: 'OAuthConnectionType', id: string, connectionType?: Types.OAuthIntegrationTypeEnum | null, expiresAt: string, isActive: boolean } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type DisconnectMicrosoftOAuthMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DisconnectMicrosoftOAuthMutation = { __typename: 'Mutation', disconnectMicrosoftOauth?: { __typename: 'DisconnectMicrosoftOAuthMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type AutotaskConnectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AutotaskConnectionQuery = { __typename: 'Query', autotaskConnection?: { __typename: 'AutotaskConnectionType', id: string, apiUsername: string, isActive?: boolean | null, apiBaseUrl?: string | null } | null };

export type AutotaskCompaniesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AutotaskCompaniesQuery = { __typename: 'Query', autotaskCompanies?: Array<{ __typename: 'AutotaskCompanyType', id?: string | null, companyName?: string | null, companyType?: number | null } | null> | null };

export type SaveAutotaskConnectionMutationVariables = Types.Exact<{
  input: Types.SaveAutotaskConnectionInput;
}>;


export type SaveAutotaskConnectionMutation = { __typename: 'Mutation', saveAutotaskConnection?: { __typename: 'SaveAutotaskConnectionMutation', autotaskConnection?: { __typename: 'AutotaskConnectionType', id: string, apiUsername: string, isActive?: boolean | null, apiBaseUrl?: string | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type DisconnectAutotaskConnectionMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DisconnectAutotaskConnectionMutation = { __typename: 'Mutation', disconnectAutotaskConnection?: { __typename: 'DisconnectAutotaskConnectionMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const OAuthConnectionsDocument = new TypedDocumentString(`
    query OAuthConnections {
  oauthConnections {
    edges {
      node {
        id
        connectionType
        expiresAt
        isActive
      }
    }
    totalCount
  }
}
    `);

export const useOAuthConnectionsQuery = <
      TData = OAuthConnectionsQuery,
      TError = unknown
    >(
      variables?: OAuthConnectionsQueryVariables,
      options?: Omit<UseQueryOptions<OAuthConnectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OAuthConnectionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OAuthConnectionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['OAuthConnections'] : ['OAuthConnections', variables],
    queryFn: fetcher<OAuthConnectionsQuery, OAuthConnectionsQueryVariables>(OAuthConnectionsDocument, variables),
    ...options
  }
    )};

useOAuthConnectionsQuery.getKey = (variables?: OAuthConnectionsQueryVariables) => variables === undefined ? ['OAuthConnections'] : ['OAuthConnections', variables];

export const useInfiniteOAuthConnectionsQuery = <
      TData = InfiniteData<OAuthConnectionsQuery>,
      TError = unknown
    >(
      variables: OAuthConnectionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OAuthConnectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OAuthConnectionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OAuthConnectionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['OAuthConnections.infinite'] : ['OAuthConnections.infinite', variables],
      queryFn: (metaData) => fetcher<OAuthConnectionsQuery, OAuthConnectionsQueryVariables>(OAuthConnectionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOAuthConnectionsQuery.getKey = (variables?: OAuthConnectionsQueryVariables) => variables === undefined ? ['OAuthConnections.infinite'] : ['OAuthConnections.infinite', variables];


useOAuthConnectionsQuery.fetcher = (variables?: OAuthConnectionsQueryVariables) => fetcher<OAuthConnectionsQuery, OAuthConnectionsQueryVariables>(OAuthConnectionsDocument, variables);

export const CreateMicrosoftOAuthUrlDocument = new TypedDocumentString(`
    mutation CreateMicrosoftOAuthUrl {
  createMicrosoftOauthUrl {
    oauthUrl {
      url
      state
    }
    errors {
      field
      message
    }
  }
}
    `);

export const useCreateMicrosoftOAuthUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMicrosoftOAuthUrlMutation, TError, CreateMicrosoftOAuthUrlMutationVariables, TContext>) => {
    
    return useMutation<CreateMicrosoftOAuthUrlMutation, TError, CreateMicrosoftOAuthUrlMutationVariables, TContext>(
      {
    mutationKey: ['CreateMicrosoftOAuthUrl'],
    mutationFn: (variables?: CreateMicrosoftOAuthUrlMutationVariables) => fetcher<CreateMicrosoftOAuthUrlMutation, CreateMicrosoftOAuthUrlMutationVariables>(CreateMicrosoftOAuthUrlDocument, variables)(),
    ...options
  }
    )};


useCreateMicrosoftOAuthUrlMutation.fetcher = (variables?: CreateMicrosoftOAuthUrlMutationVariables) => fetcher<CreateMicrosoftOAuthUrlMutation, CreateMicrosoftOAuthUrlMutationVariables>(CreateMicrosoftOAuthUrlDocument, variables);

export const CompleteMicrosoftOAuthDocument = new TypedDocumentString(`
    mutation CompleteMicrosoftOAuth($code: String!) {
  completeMicrosoftOauth(code: $code) {
    connection {
      id
      connectionType
      expiresAt
      isActive
    }
    errors {
      field
      message
    }
  }
}
    `);

export const useCompleteMicrosoftOAuthMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteMicrosoftOAuthMutation, TError, CompleteMicrosoftOAuthMutationVariables, TContext>) => {
    
    return useMutation<CompleteMicrosoftOAuthMutation, TError, CompleteMicrosoftOAuthMutationVariables, TContext>(
      {
    mutationKey: ['CompleteMicrosoftOAuth'],
    mutationFn: (variables?: CompleteMicrosoftOAuthMutationVariables) => fetcher<CompleteMicrosoftOAuthMutation, CompleteMicrosoftOAuthMutationVariables>(CompleteMicrosoftOAuthDocument, variables)(),
    ...options
  }
    )};


useCompleteMicrosoftOAuthMutation.fetcher = (variables: CompleteMicrosoftOAuthMutationVariables) => fetcher<CompleteMicrosoftOAuthMutation, CompleteMicrosoftOAuthMutationVariables>(CompleteMicrosoftOAuthDocument, variables);

export const DisconnectMicrosoftOAuthDocument = new TypedDocumentString(`
    mutation DisconnectMicrosoftOAuth($id: String!) {
  disconnectMicrosoftOauth(id: $id) {
    success
    errors {
      field
      message
    }
  }
}
    `);

export const useDisconnectMicrosoftOAuthMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DisconnectMicrosoftOAuthMutation, TError, DisconnectMicrosoftOAuthMutationVariables, TContext>) => {
    
    return useMutation<DisconnectMicrosoftOAuthMutation, TError, DisconnectMicrosoftOAuthMutationVariables, TContext>(
      {
    mutationKey: ['DisconnectMicrosoftOAuth'],
    mutationFn: (variables?: DisconnectMicrosoftOAuthMutationVariables) => fetcher<DisconnectMicrosoftOAuthMutation, DisconnectMicrosoftOAuthMutationVariables>(DisconnectMicrosoftOAuthDocument, variables)(),
    ...options
  }
    )};


useDisconnectMicrosoftOAuthMutation.fetcher = (variables: DisconnectMicrosoftOAuthMutationVariables) => fetcher<DisconnectMicrosoftOAuthMutation, DisconnectMicrosoftOAuthMutationVariables>(DisconnectMicrosoftOAuthDocument, variables);

export const AutotaskConnectionDocument = new TypedDocumentString(`
    query AutotaskConnection {
  autotaskConnection {
    id
    apiUsername
    isActive
    apiBaseUrl
  }
}
    `);

export const useAutotaskConnectionQuery = <
      TData = AutotaskConnectionQuery,
      TError = unknown
    >(
      variables?: AutotaskConnectionQueryVariables,
      options?: Omit<UseQueryOptions<AutotaskConnectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AutotaskConnectionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AutotaskConnectionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AutotaskConnection'] : ['AutotaskConnection', variables],
    queryFn: fetcher<AutotaskConnectionQuery, AutotaskConnectionQueryVariables>(AutotaskConnectionDocument, variables),
    ...options
  }
    )};

useAutotaskConnectionQuery.getKey = (variables?: AutotaskConnectionQueryVariables) => variables === undefined ? ['AutotaskConnection'] : ['AutotaskConnection', variables];

export const useInfiniteAutotaskConnectionQuery = <
      TData = InfiniteData<AutotaskConnectionQuery>,
      TError = unknown
    >(
      variables: AutotaskConnectionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AutotaskConnectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AutotaskConnectionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AutotaskConnectionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['AutotaskConnection.infinite'] : ['AutotaskConnection.infinite', variables],
      queryFn: (metaData) => fetcher<AutotaskConnectionQuery, AutotaskConnectionQueryVariables>(AutotaskConnectionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAutotaskConnectionQuery.getKey = (variables?: AutotaskConnectionQueryVariables) => variables === undefined ? ['AutotaskConnection.infinite'] : ['AutotaskConnection.infinite', variables];


useAutotaskConnectionQuery.fetcher = (variables?: AutotaskConnectionQueryVariables) => fetcher<AutotaskConnectionQuery, AutotaskConnectionQueryVariables>(AutotaskConnectionDocument, variables);

export const AutotaskCompaniesDocument = new TypedDocumentString(`
    query AutotaskCompanies {
  autotaskCompanies {
    id
    companyName
    companyType
  }
}
    `);

export const useAutotaskCompaniesQuery = <
      TData = AutotaskCompaniesQuery,
      TError = unknown
    >(
      variables?: AutotaskCompaniesQueryVariables,
      options?: Omit<UseQueryOptions<AutotaskCompaniesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AutotaskCompaniesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AutotaskCompaniesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AutotaskCompanies'] : ['AutotaskCompanies', variables],
    queryFn: fetcher<AutotaskCompaniesQuery, AutotaskCompaniesQueryVariables>(AutotaskCompaniesDocument, variables),
    ...options
  }
    )};

useAutotaskCompaniesQuery.getKey = (variables?: AutotaskCompaniesQueryVariables) => variables === undefined ? ['AutotaskCompanies'] : ['AutotaskCompanies', variables];

export const useInfiniteAutotaskCompaniesQuery = <
      TData = InfiniteData<AutotaskCompaniesQuery>,
      TError = unknown
    >(
      variables: AutotaskCompaniesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AutotaskCompaniesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AutotaskCompaniesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AutotaskCompaniesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['AutotaskCompanies.infinite'] : ['AutotaskCompanies.infinite', variables],
      queryFn: (metaData) => fetcher<AutotaskCompaniesQuery, AutotaskCompaniesQueryVariables>(AutotaskCompaniesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAutotaskCompaniesQuery.getKey = (variables?: AutotaskCompaniesQueryVariables) => variables === undefined ? ['AutotaskCompanies.infinite'] : ['AutotaskCompanies.infinite', variables];


useAutotaskCompaniesQuery.fetcher = (variables?: AutotaskCompaniesQueryVariables) => fetcher<AutotaskCompaniesQuery, AutotaskCompaniesQueryVariables>(AutotaskCompaniesDocument, variables);

export const SaveAutotaskConnectionDocument = new TypedDocumentString(`
    mutation SaveAutotaskConnection($input: SaveAutotaskConnectionInput!) {
  saveAutotaskConnection(input: $input) {
    autotaskConnection {
      id
      apiUsername
      isActive
      apiBaseUrl
    }
    errors {
      field
      message
    }
  }
}
    `);

export const useSaveAutotaskConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveAutotaskConnectionMutation, TError, SaveAutotaskConnectionMutationVariables, TContext>) => {
    
    return useMutation<SaveAutotaskConnectionMutation, TError, SaveAutotaskConnectionMutationVariables, TContext>(
      {
    mutationKey: ['SaveAutotaskConnection'],
    mutationFn: (variables?: SaveAutotaskConnectionMutationVariables) => fetcher<SaveAutotaskConnectionMutation, SaveAutotaskConnectionMutationVariables>(SaveAutotaskConnectionDocument, variables)(),
    ...options
  }
    )};


useSaveAutotaskConnectionMutation.fetcher = (variables: SaveAutotaskConnectionMutationVariables) => fetcher<SaveAutotaskConnectionMutation, SaveAutotaskConnectionMutationVariables>(SaveAutotaskConnectionDocument, variables);

export const DisconnectAutotaskConnectionDocument = new TypedDocumentString(`
    mutation DisconnectAutotaskConnection {
  disconnectAutotaskConnection {
    success
    errors {
      field
      message
    }
  }
}
    `);

export const useDisconnectAutotaskConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DisconnectAutotaskConnectionMutation, TError, DisconnectAutotaskConnectionMutationVariables, TContext>) => {
    
    return useMutation<DisconnectAutotaskConnectionMutation, TError, DisconnectAutotaskConnectionMutationVariables, TContext>(
      {
    mutationKey: ['DisconnectAutotaskConnection'],
    mutationFn: (variables?: DisconnectAutotaskConnectionMutationVariables) => fetcher<DisconnectAutotaskConnectionMutation, DisconnectAutotaskConnectionMutationVariables>(DisconnectAutotaskConnectionDocument, variables)(),
    ...options
  }
    )};


useDisconnectAutotaskConnectionMutation.fetcher = (variables?: DisconnectAutotaskConnectionMutationVariables) => fetcher<DisconnectAutotaskConnectionMutation, DisconnectAutotaskConnectionMutationVariables>(DisconnectAutotaskConnectionDocument, variables);
